module.exports = __webpack_public_path__ + "img/hvac-mechanical-maintenance-05-xlarge.48abe39a.jpg";